import React, { Component } from "react";
import { DatePicker, Button, Select, message ,Modal ,Radio } from "antd";
import SelectProvince from '../../common/SelectProvince';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import API_URL from "../../../common/url";
import $ from "../../../common/AjaxRequest";
import moment from "moment";

const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {},
        visible:false,
        isDetail:true
    }

    componentDidMount(){
        this.getDepartmentList();
    }

    getDepartmentList = () => {
        const options = {
            url: API_URL.manhour.queryManHourRecordDepartment,
            data: { isFilter: 1 },
            dataType: 'json',
            doneResult: ( res => {
                this.setState({ departmentList: res.data });
            }),
        };
        $.sendRequest(options);
    }

    search = () => {
        const {
            searchParams,
            searchParams: {
                areaParams,
            },
        } = this.state;
        this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
    };
    
    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        switch (key) {
            case 'pmUser':
            case 'user':
            case 'leaderUser':
            case 'position':
            case 'investigation':
                {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                this.handleFilterChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                this.handleFilterChange(searchParams);
                break;
        }
        this.setState({ searchParams });
    };

    export = () => {
        const {searchParams} = this.state
        this.props.export(searchParams)
    }
    
    render() {
        const { searchParams, visible ,isDetail } = this.state;
        return (
            <div>
                <div className="search-bar" style={{ marginBottom: 15 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">人员</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 142 }}
                        params={{ limit: 20 }}
                        value={searchParams.userName}
                        placeholder="输入姓名/工号检索"
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={option => this.handleChange(option, 'user')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">项目简称</label>
                    <SearchRetrieve
                        keyword='investigationName'
                        style={{ width: 160 }}
                        params={{ limit: 20 , isHistory: 'FALSE' }}
                        placeholder="输入名称检索"
                        value={searchParams.investigationName}
                        url={API_URL.investigation.queryInvestigationByName}
                        config={{ id: 'investigationId', name: 'investigationName' }}
                        onChange={option => this.handleChange(option, 'investigation')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">直线主管</label>
                    <SearchRetrieve
                        keyword='keyWord'
                        style={{ width: 160 }}
                        placeholder="输入工号或姓名检索"
                        url={API_URL.team.queryEmpListByRoleCode}
                        params={{ limit: 20, needPosition:'TRUE', workStatus:'ALL'}}
                        value={searchParams.leaderUserName}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={(value) => this.handleChange(value, 'leaderUser')}
                    />
                </div>
                <div className="search-item" >
                    <label className="ui-label" >
                        离职日期
                    </label>
                    <DatePicker
                        format={'YYYY-MM-DD'}
                        value={searchParams.leftTime ? moment(searchParams.leftTime) : null}
                        onChange={(date, dateString) => this.handleChange(dateString, "leftTime")}
                        allowClear={true}
                        style={{ width: 100, verticalAlign: "middle" }}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">PM</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 140 }}
                        placeholder="输入姓名/工号检索"
                        value={searchParams.pmUserName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryUserByKey}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={value => this.handleChange(value, 'pmUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">是否完成交接</label>
                    <Select
                        placeholder="请选择"
                        style={{ width: 120 }}
                        value={ searchParams.completeHandover }
                        allowClear={true}
                        onChange={(value) => this.handleChange(value, "completeHandover")}
                    >
                        <Option key={1} value={1}>是</Option>
                        <Option key={0} value={0}>否</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                </div>
            </div>
            </div>
            
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/user/userDimission/Filter.js